/**
 * 视频详情页的打点
 */

export default {
  /**
   * 视频详情页内点击
   * @param {*} click 点击
      full | 点击全屏播放
      mute|点击静音按键（音量高低调整不报，仅报点击按键切换静音）；
      keyboard_play | 使用键盘空格按键切换播放/暂停
      keyboard_fast  | 键盘向右快进10秒
      keyboard_rewind  | 键盘向左快退10秒
      playvideo|视频播放;（仅报开始播放，播放中暂停又切换播放不报）
      speed_0.5 | 点击倍速切换0.5倍速播放；
      speed_1.5  | 点击倍速切换1.5倍速播放；
      speed_2  | 点击倍速切换2倍速播放；
      end_1 | 点击播放结束页第1个内容；
      end_2 | 点击播放结束页第2个内容；
      end_3| 点击播放结束页第3个内容；
      end_4 | 点击播放结束页第4个内容；
      end_5 | 点击播放结束页第5个内容；
      end_6 | 点击播放结束页第6个内容；
      replay|播放结束页的重播按键;
      next|播放结束页的下一个按键;
      subscribe|订阅按键点击
      playvideo|视频播放;
      suspendvideo|视频暂停;
      endvideo|播放结束
      subscribe|订阅按键点击/加入学习按键点击
      phone|手机观看;
      courseware|练习文档;
      wechatshare|微信分享;
      blogshare|微博分享;
      collect|收藏;
      praise|点赞;
      download|下载软件入口点击;
      analysis|图文解析tab点击;
      case|案例tab点击;
      edu|精品课tab点击;
      content|内容点击;
      replay|重播;
      next|下一个;
      appraise|评价点击;
      confirm|提交评价点击;
      Ahelp|视频窗下方入口有帮助点击;
      Anohelp|视频窗下方入口无帮助点击;
      Bhelp|播放结束页有帮助点击;
      Bnohelp|播放结束页无帮助点击;
      mobile|手机上如何操作;
      pc|电脑上如何操作;
      banner|视频窗下方Banner点击;
      bannerclose|视频窗下方banner关闭按键;
      use|体验功能按键点击;
      speed|倍速点击;
      endcontent|播放结束页内容点击；
      ok|点击加入学习引导弹窗的【好的】
      cancel|取消加入学习
      off_one|关闭提醒-当前课的提醒
      off_all|关闭提醒-所有课的提醒
   * @param {*} type 视频详情页展示的教程ID
   * @param {*} series 系列课ID
   * @param {*} source 来源
      personal|个人版;
      enterprise|企业版;
      phone|手机版
   * @param {*} area 区域
      rightlist|右侧目录区域;
      righthot|右侧相关技巧区域展示；
      course|右侧推荐课程区域展示；
      edu|进阶课推荐区域;
      end|播放结束后推荐弹窗;
      livebroadcast|热门直播;（企业版详情页右侧）
   * @param {*} image baner的ID（根据后台配置生成的bannerID上报）
   * @param {*} listid 点击视频详情页内其他技巧时上报
   */
  detailsSkillvideoClick({ click, type, series, source, area, image, listid }) {
    this.collect('details_skillvideo_click', {
      click,
      type,
      series,
      source,
      area,
      image,
      listid,
    });
  },

  /**
   * 视频详情页内展示
   * @param {*} show 展示内容
      autoplay|触发系列课连播切换至下一个视频播放时上报
      video_0.3| 视频播放至30%;
      video_0.5| 视频播放至50%;
      video_0.9| 视频播放至90%;
      video_1| 视频播放至100%;
      scroll | 进入页面有滚动行为即上报;
      article_0.3|图文阅读至30%;
      article_0.5|图文阅读至50%;
      article_0.9|图文阅读至90%;
      article_1|图文阅读至100%;（页面滚动至图文底部即上报，无需滚动至页尾底部）
      subscribe|订阅按键展示;
      overrecommend|视频结束页展示
      details|详情页;
      appraise|点击评价后的“用户评价”弹窗展示;
      banner|视频窗下方Banner展示;
      use|体验功能按键展示;
      righthot|右侧相关技巧区域展示；
      course|右侧推荐课程区域展示；
      popup_add|加入学习引导弹窗展示
      popup_wechat|引导关注公众号弹窗
      popup_videopause|视频暂停弹窗展示；
      popup_phone|手机观看弹窗展示；
   * @param {*} add 加入学习按键状态
      0|无加入学习按键
      1|加入我的学习
      2|已加入学习
   * @param {*} type 教程ID
   * @param {*} series 系列课ID
   * @param {*} image baner的ID（根据后台配置生成的bannerID上报）
   * @param {*} userid
   * @param {*} component 所属组件
   * @param {*} source 来源
   */
  detailsSkillvideoShow({ show, type, series, image, userid, component, source }) {
    this.collect('details_skillvideo_show', {
      show,
      type,
      series,
      image,
      userid,
      component,
      source,
    });
  },

  /**
   * 视频详情页结束
   * @param {*} view 页尾是否展示
      yes|有展示;
      no|无展示;
   * @param {*} time 停留时间以秒为单位进行上报
   * @param {*} type 教程ID
   * @param {*} source 来源
      personal|个人版;
      enterprise|企业版;
   */
  detailsSkillvideoEnd({ view, time, type, source }) {
    this.collect('details_skillvideo_end', {
      view,
      time,
      type,
      source,
    });
  },
};
